export const SET_CENTER = "SET_CENTER";
export const SET_CITY_FILTER_OPTIONS = "SET_CITY_FILTER_OPTIONS";
export const SET_SELECTED_CITY = "SET_SELECTED_CITY";
export const SET_MEDIA_TYPE_FILTER_OPTIONS = "SET_MEDIA_TYPE_FILTER_OPTIONS";
export const SET_LIGHTING_FILTER_OPTIONS = "SET_LIGHTING_FILTER_OPTIONS";
export const SET_ZONES_FILTER_OPTIONS = "SET_ZONES_FILTER_OPTIONS";
export const SET_MEDIA_OWNER_FILTER_OPTIONS = "SET_MEDIA_OWNER_FILTER_OPTIONS";
export const SET_BRAND_FILTER_OPTIONS = "SET_BRAND_FILTER_OPTIONS";
export const SET_LOCATION_FILTER_OPTIONS = "SET_LOCATION_FILTER_OPTIONS";
export const SET_SELECTED_MEDIA_TYPE = "SET_SELECTED_MEDIA_TYPE";
export const SET_SELECTED_LIGHTING = "SET_SELECTED_LIGHTING";
export const SET_SELECTED_ZONES = "SET_SELECTED_ZONES";
export const SET_SELECTED_MEDIA_OWNER = "SET_SELECTED_MEDIA_OWNER";
export const SET_SELECTED_BRAND = "SET_SELECTED_BRAND";
export const SET_SELECTED_LOCATION = "SET_SELECTED_LOCATION";
export const SET_SELECTED_MAP_ICONS = "SET_SELECTED_MAP_ICONS";
export const SET_SELECTED_TRAFFIC_DENSITY = "SET_SELECTED_TRAFFIC_DENSITY";
export const SET_SELECTED_SITE_GRADE = "SET_SELECTED_SITE_GRADE";
export const SET_SITES_LOADED = "SET_SITES_LOADED";
export const SET_INV_SITES_LOADED = "SET_INV_SITES_LOADED";
export const SET_SEARCHDATA = "SET_SEARCHDATA";
export const SET_SELECTED_AREAS = "SET_SELECTED_AREAS";
export const SET_POI_MARKERS = "SET_POI_MARKERS";
export const UPDATE_CART = "UPDATE_CART";
export const SET_MARKER_DATA = "SET_MARKER_DATA";
export const SET_CURRENT_ROUTE = "SET_CURRENT_ROUTE";
export const SET_PLANO_CAMPAIGNS = "SET_PLANO_CAMPAIGNS";
export const SET_VIEW_CAMPAIGN_PANE = "SET_VIEW_CAMPAIGN_PANE";
export const SET_SHARING_USERS = "SET_SHARING_USERS";
export const SET_SHARED_PLANO_CAMPAIGNS = "SET_SHARED_PLANO_CAMPAIGNS";
export const SET_SIDE_BAR_OPEN = "SET_SIDE_BAR_OPEN";
export const SET_SITE_CODE_ARRAY_DATA = "SET_SITE_CODE_ARRAY_DATA";

export const SET_FILTER_VALUES = "SET_FILTER_VALUES";
export const SET_LOCATE_SITE_ARRAY = "SET_LOCATE_SITE_ARRAY";
export const SET_LOCATE_SITE_MARKER_DATA = "SET_LOCATE_SITE_MARKER_DATA";
export const SET_LOADER_STATE = "SET_LOADER_STATE";
export const ADD_SEARCHDATA = "ADD_SEARCHDATA";
export const SET_CITY_WARD_DATA =  "SET_CITY_WARD_DATA";
export const SET_SEARCHDATA_COUNT = "SET_SEARCHDATA_COUNT";
export const RESET_SEARCHDATA = "RESET_SEARCHDATA";
export const AUTH_USER = "AUTH_USER";
export const UNAUTH_USER = "UNAUTH_USER";
export const AUTH_ERROR = "AUTH_ERROR";
export const FETCH_DISTINCT_BRANDS = "FETCH_DISTINCT_BRANDS";
export const RESET_POI = "RESET_POI";



// WEBPACK FOOTER //
// ./src/v3/actions/types.js